<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <vs-row
      vs-w="12"
      class="my-5 filter-container flex justify-between"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="4" />
      <vs-col
        vs-w="7"
        class="flex justify-end"
      >
        <div class="flex flex-row gap-x-4 items-stretch">
          <div class="flex items-center w-full">
            <select-with-multiple
              v-model="filters.company"
              placeholder="Select company"
              :options="companiesOptions"
              :activate-search="true"
            />
          </div>
          <div class="flex items-center w-full">
            <date-picker
              type="month"
              format="MMM YYYY"
              value-type="format"
              placeholder="Select Month"
              v-model="filters.month_year"
              :clearable="false"
            />
          </div>
          <div class="flex items-center">
            <vs-button
              type="border"
              color="primary"
              class="self-center font-semibold"
              style="min-width: 100px"
              @click="resetFilters"
            >
              Reset
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="p-5 flex flex-col bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-5"
        @fetch="fetchDailyActivity"
      >
        <template #start>
          <vs-button
            v-if="isUserCanAccessMenu(permission.name, 'edit')"
            class="button shadow-secondary font-semibold ml-5"
            color="secondary"
            @click="sendDailyActivityReport"
          >
            Send Report
          </vs-button>
        </template>
      </table-top>
      <data-table
        class="my-5"
        :loading="isBusy"
        :table-header="tableHeaders"
        :table-data="dailyTripData"
        :sort-by="filters.sortBy"
        :sort-dir="filters.sortDir"
        body-height="100vh"
        @sort="sort"
      >
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <div
              v-if="isUserCanAccessMenu(permission.name, 'edit')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="goToManage(row)"
            >
              <img
                :src="require('@/assets/shipo-icon-see.svg')"
                class="w-8 h-8"
              >
            </div>
            <div
              v-if="isUserCanAccessMenu(permission.name, 'view')"
              class="flex items-center justify-center icon-transparent-bg"
              @click="goToDetail(row)"
            >
              <img
                :src="require('@/assets/shipo-icon-file-download-primary.svg')"
                class="w-5 h-5"
              >
            </div>
          </div>
        </template>
        <template #tug_name="{ row }">
          <span>{{ row.tug_name }}</span>
        </template>
        <template #barge_name="{ row }">
          <span>{{ row.barge_name }}</span>
        </template>
        <template #buyer="{ row }">
          <span>{{ row.buyer }}</span>
        </template>
        <template #trip_number="{ row }">
          <span>{{ row.trip_number }}</span>
        </template>
        <template #actual_trip_start="{ row }">
          <span>{{ row.actual_trip_start ? moment(row.actual_trip_start).format('DD MMM YYYY HH:mm') : '-' }}</span>
        </template>
        <template #actual_trip_end="{ row }">
          <span>{{ row.actual_trip_end ? moment(row.actual_trip_end).format('DD MMM YYYY HH:mm') : '-' }}</span>
        </template>
      </data-table>
      <table-bottom @fetch="fetchDailyActivity" />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import SelectWithMultiple from "@/components/selectWithMultiple/index.vue";
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'

export default {
  components: {
    DataTable,
    DatePicker,
    TableBottom,
    TableTop,
    SelectWithMultiple
  },
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  data() {
    return {
      dailyActiviyData: JSON.parse(localStorage.getItem('dailyActivityData')),
      isBusy: false,
      filters: {
        sortBy: '',
        sortDir: '',
        company: [],
        month_year: moment().startOf('month').format('MMM YYYY')
      },
      companiesOptions: [],
      tableHeaders: [
        { key: 'action', label: 'Action' },
        { key: 'tug_name', label: 'Tug', sortable: true },
        { key: 'barge_name', label: 'Barge', sortable: true },
        { key: 'buyer', label: 'Buyer', sortable: true },
        { key: 'trip_number', label: 'Service Trip', sortable: true },
        { key: 'actual_trip_start', label: 'Start Trip', sortable: true },
        { key: 'actual_trip_end', label: 'End Trip', sortable: true }
      ],
      dailyTripData: []
    }
  },
  async mounted() {
    if (this.$route.query.month_year) {
      const monthYearParam = this.$route.query.month_year
      try {
        const parsedDate = moment(monthYearParam, 'MM-YYYY')
        if (parsedDate.isValid()) {
          this.filters.month_year = parsedDate.format('MMM YYYY')
        }
      } catch (e) {
        this.showFailedNotification(this, 'Invalid month_year parameter format, please try again')
      }
    }
    this.fetchDailyActivity()
    this.fetchCompany()
  },
  computed: {
    ...mapGetters({
      totalPage: 'Table/totalPage',
      totalData: 'Table/totalData',
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      dailyTrip: 'DailyTripActivities/dailyTrip',
      companies: 'Companies/companies'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    }
  },
  watch: {
    dailyTrip: {
      immediate: true,
      handler(val) {
        this.dailyTripData = val

      }
    },
    companies: {
      handler(val) {
        if (val) {
          this.companiesOptions = val.map(item => ({
            text: item.code,
            value: item.code
          }));
        }
      }
    },
    filters: {
      deep: true,
      handler() {
        this.fetchDailyActivity()
      }
    }
  },
  methods: {
    async fetchDailyActivity() {
      try {
        this.isBusy = true
        const apiFilters = {
          sortDir: (this.filters?.sortDir || 'desc').toUpperCase(),
          sortBy: this.filters?.sortBy || 'actual_trip_start',
          page: this.currentPage || 1,
          limit: this.pageSize || 10,
          month_year: this.moment(this.filters.month_year, 'MMM YYYY').format('MM-YYYY')
        };

        if (this.filters.company.length !== 0) {
          apiFilters['company'] = this.filters.company.map(({ value }) => value).join(',');
        }

        await this.$store.dispatch('DailyTripActivities/fetchDailyTrip', apiFilters)

        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch Daily Activities list, please try again')
      }
    },
    async sendDailyActivityReport() {
      this.isBusy = true
      try {
        await this.$store.dispatch('DailyTripActivities/postEmailDailyTripActivities')

        this.showSuccessNotification(this, 'Daily report email successfully sent..')
      } catch ({ data }) {
        const message = data?.error?.message || 'Failed to send daily report email, please try again'
        this.showFailedNotification(this, message, 'Error')
      } finally {
        this.isBusy = false
      }
    },
    sort(sortBy, sortDir) {
      this.filters = {
        ...this.filters,
        sortBy: sortBy,
        sortDir: sortDir
      }
      this.fetchDailyActivity()
    },
    goToManage(row) {
      localStorage.setItem('dailyActivityData', JSON.stringify(row))
      this.$router.push({ name: 'ManageActivity' })
    },
    goToDetail(row) {
      localStorage.setItem('dailyActivityData', JSON.stringify(row))
      this.$router.push({ name: 'DailyActivityReportDetail', params: { blu_id: row.blu_id } })
    },
    async fetchCompany() {
      try {
        await this.$store.dispatch('Companies/fetchCompanies', {
          is_master_data: true,
          type: 'SITE_OWNER',
          status: true,
          sort_dir: 'asc',
          sort_by: 'name',
          page: 1,
          limit: 1000
        })
      } catch (e) {
        this.showFailedNotification(this, 'Failed to fetch companies, please try again')
      }
    },
    resetFilters() {
      this.filters = this.$options.data().filters
      this.fetchDailyActivity()
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-container {
  @apply w-full p-5 mt-5 flex flex-row items-center bg-white rounded-lg;
}
</style>
